import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";

import {
  ErrorModal,
  InputTextVertical,
  SuccessModal,
  VerticalInputFormLayout,
} from "@components";

import { TicketTypeSettingsType } from "@type/tickets/ticket-settings";

import { addNewETicketSettings } from "@api/e-tickets/ticket-settings";

import { STATUS } from "@constants/status.hrm";
import { URLS } from "@constants/urls";

const { TICKET_TYPES } = URLS;
const { SUCCESS, FAILED } = STATUS;

export const TicketTypeForm = ({ data }: any) => {
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);

  const { handleAddNewType } = data || {};

  const {
    reset,
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<TicketTypeSettingsType>();

  // error and success modal
  const closeErrorModal = () => setIsErrorModalOpen(false);
  const successAction = () => {
    reset();
    setIsSuccessModalOpen(false);
  };

  useEffect(() => {
    const reset = () => {
      setIsErrorModalOpen(false);
      setIsSuccessModalOpen(false);
    };
    return reset();
  }, []);

  const onSubmit: SubmitHandler<TicketTypeSettingsType> = (
    typeData: TicketTypeSettingsType,
  ) => {
    addNewETicketSettings(TICKET_TYPES, typeData, (response) => {
      closeErrorModal();
      if (response.status === SUCCESS) {
        setIsSuccessModalOpen(true);
        handleAddNewType(response.data);
      } else if (response.status === FAILED) setIsErrorModalOpen(true);
    });
  };

  return (
    <>
      {/* MODAL SECTION */}
      <>
        <SuccessModal
          isModalOpen={isSuccessModalOpen}
          action={successAction}
          subtitle="Ticket Type Created Successfully"
        />
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
      </>
      {/* MODAL SECTION */}
      <VerticalInputFormLayout
        label="TICKETS.SETTINGS.TAB.TYPE.FORM.LABEL"
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
      >
        <InputTextVertical
          label="TICKETS.SETTINGS.TAB.TYPE.FORM.INPUT.NAME"
          register={{
            ...register("name", { required: "Name is Required" }),
          }}
          error={errors}
          required
          cols={3}
        />
      </VerticalInputFormLayout>
    </>
  );
};
